/* eslint-disable no-console */
/* eslint-disable no-bitwise */
import get from "lodash/get";
import env from "environment";

const isPartnerSite = () => env.REACT_APP_STANDALONE_DOMAIN !== window.location.host;

const isMossyoak = () => {
  isPartnerSite() && window.location.host.includes("mossy");
};

/**
 * @name pluralize
 * @summary general helper for plurization of strings
 * @param  {Number} nCount  is the number to pluralize
 * @param  {String} pString is the string to pluralize
 * @returns {String} formatted string
 */
function pluralize(nCount = 0, pString, includeCount = true) {
  let copy = "";
  if (nCount === 1) {
    copy = pString;
  } else {
    copy = `${pString}s`;
  }

  if (includeCount) {
    return `${nCount} ${pString}s`;
  }

  return copy;
}

const toColor = (val) => {
  const str = val.toString();
	if (!str) return;
	let hash = 0;
	for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
	let color = "#";
	for (let i = 0; i < 3; i++) {
		const value = (hash >> (i * 8)) & 0xFF;
		color += (`00${value.toString(16)}`).substr(-2);
	}
	return color;
};

/**
 * Converts base65 data into a File object
 * @param {String} data
 * @param {String} filename
 * @param {String} fileType
 * @returns File
 */
const dataURLtoFile = async (data, filename, fileType = "image/png") => {
  const res = await fetch(data);
  const blob = await res.blob();
  const file = new File([blob], filename, { type: fileType });
  return file;
};

const getUserShortName = (user) => {
  let name = user.first_name || user.last_name || user.fullname || "";
  name = name.trim();
  if (name.length > 0) {
    return name.charAt(0);
  }

  return "cr";
};

const getLandSearchRoute = () => {
  if (isPartnerSite()) {
    const company = window.location.host.split(".")[0];
    return `${window.location.protocol}//${company}.${env.REACT_APP_STANDALONE_DOMAIN}/app/lands/search/40.41500741724772/-99.8720887852595/4/sale/all/all`;
  }

  return `${env.REACT_APP_DOMAIN}/app/lands/search/40.41500741724772/-99.8720887852595/4/sale/all/all`;
};

const parseTenantFromURL = (url) => {
  if (!url) return;

  const domainRegex = new RegExp(`(\\w?[-\\w]+).(${env.REACT_APP_STANDALONE_DOMAIN}|${env.REACT_APP_CG_STANDALONE_DOMAIN})`);
  const match = url.match(domainRegex);

  return get(match, "[1]", url);
};

const redirectToNewApp = (path) => {
   if (typeof window !== "undefined") {
    let subdomain = "";
    const tenant = parseTenantFromURL(window.location.host);

    if (tenant !== window.location.host) {
      subdomain = `${tenant}.`;
    }

    const url = `https://${subdomain}${env.REACT_APP_CG_STANDALONE_DOMAIN}${path}`;

    return window.location.assign(url);
  }

  return "#";
};


export {
  parseTenantFromURL,
  getUserShortName,
  isPartnerSite,
  pluralize,
  dataURLtoFile,
  toColor,
  isMossyoak,
  getLandSearchRoute,
  redirectToNewApp,
};
